
export default {
    main: {
        1: [
            "ちょっとシャイなのかもしれませんが、頑張って会議に参加されましたね！",
            "ちょっと発言しづらかったかもしれませんが、頑張って会議に参加されましたね！",
            "なれない会議の仕方だったかもしれませんが、ちゃんと参加できましたね！",
            "発言するのは大変だったかもしれませんが、しっかり会議に参加できましたね！",
            "やりづらい環境だったかもしれませんが、ちゃんと会議に参加できましたね！",
        ],
        2: [
            "きっと次の会議を盛り上げるための助走だったのでは？",
            "次の会議ではより積極的に発言できそうですね！",
            "控えめにしてましたが、次からは会議を引っ張る予定ですよね！",
            "全体のバランスを考えられると次は会議の主役になれるのでは？",
            "次の会議ではもっと活発に意見交換できそうですね！",
        ],
        3: [
            "きっとあなたは会議を盛り上げるのには欠かせない逸材では？",
            "Web会議でこの発言力、面と向かっての破壊力すごそうですね！",
            "素敵なしゃべり方であなたの株はぐんと上がったのでは！",
            "今日の会議で最も活躍した一人といっても過言ありません！",
            "あなたの素敵な発言の数々で良い会議になったのでは？",
        ],
        4: [
            "きっとあなたは会議を引っ張っていくリーダータイプなのでは？",
            "あなたなしでは会議は成り立たないと、みな思っているのでは！",
            "今日の会議の主役はあなた！　みんな思わず頼ってしまうはず！",
            "会議に参加した人達を引きつけたやまない振る舞いでした！",
            "はなし家レベルで今日の会議を引っ張っていました！　すばらしい！",
        ],
        5: [
            "この素敵なしゃべり方は、もはやあなたはWeb会議マスター！",
            "この素敵なしゃべり方は、もはやあなたはWeb会議大将軍！",
            "完璧すぎる会議の立ち振る舞い、最高に素敵です！",
            "会議に参加した人達を完全に魅了していたはず！　さすがです！",
            "素晴らしすぎて何も言うことがありません。免許皆伝です！",
        ],
    },
    title: {
        1: [
            "粗茶ですが",
        ],
        2: [
            "あはれなり",
        ],
        3: [
            "いとをかし",
        ],
        4: [
            "褒美をとらす",
        ],
        5: [
            "天晴れ",
        ],
    },
}

